import { AcceptEditListingRequestResponse } from 'api/laborerPortalAPI/marketplace'
import { CallAPIAction, Status } from 'api/types'
import Actions from 'redux/actions'

type State = {} & Status

const initialState: State = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_ASYNC,
    Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_SUCCESS,
    Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_FAIL,
    AcceptEditListingRequestResponse
  >,
) => {
  switch (action.type) {
    case Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_ASYNC:
    case Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_SUCCESS:
    case Actions.ACCEPT_LABORER_EDIT_LISTING_REQUEST_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
